import { Dispatch, SetStateAction } from 'react'

import { Button } from '@mui/material'
import { CourseBlockState, VideoSettingsState } from 'features/videos/service'
import { Course } from 'services/courses'

import { CourseBlock } from './course-block/CourseBlock'

type Props = {
  courseBlocks: CourseBlockState[]
  courses?: Course[]
  setCourseBlocks: Dispatch<SetStateAction<CourseBlockState[]>>
  setVideoSettingsState: Dispatch<SetStateAction<VideoSettingsState>>
  videoSettingsState: VideoSettingsState
}

export const VideoSettings = ({
  courseBlocks,
  courses,
  setCourseBlocks,
  setVideoSettingsState,
  videoSettingsState,
}: Props) => {
  const selectedCourseIds = Array.from(
    new Set(courseBlocks.map(block => block.courseId).filter((id): id is number => id !== null))
  )
  const hasAvailableCourses = (courses?.length || 0) > selectedCourseIds.length
  const allBlocksCompleted = courseBlocks.every(
    block => block.courseId !== null && block.selectedPlaylistsIds.length > 0
  )
  const canAddCourseBlock = hasAvailableCourses && allBlocksCompleted

  const addCourseBlock = () => {
    if (!canAddCourseBlock) {
      return
    }

    setCourseBlocks(prev => [
      ...prev,
      {
        id: crypto.randomUUID(),
        courseId: null,
        selectedPlaylistsIds: [],
        tabValue: false,
      },
    ])
  }

  const removeCourseBlock = (blockId: string) => {
    const block = courseBlocks.find(b => b.id === blockId)

    if (block) {
      setVideoSettingsState(prev => {
        const updated = { ...prev }

        block.selectedPlaylistsIds.forEach(id => delete updated[id])

        return updated
      })
    }

    setCourseBlocks(prev => prev.filter(b => b.id !== blockId))
  }

  const updateCourseBlock = (blockId: string, updates: Partial<CourseBlockState>) => {
    setCourseBlocks(prev =>
      prev.map(block => (block.id === blockId ? { ...block, ...updates } : block))
    )
  }

  return (
    <>
      {courseBlocks.map(block => (
        <CourseBlock
          key={block.id}
          block={block}
          canRemove={courseBlocks.length > 1}
          courses={courses}
          onRemove={() => removeCourseBlock(block.id)}
          onUpdate={updates => updateCourseBlock(block.id, updates)}
          setVideoSettingsState={setVideoSettingsState}
          usedCourseIds={selectedCourseIds}
          videoSettingsState={videoSettingsState}
        />
      ))}

      <Button
        disabled={!canAddCourseBlock}
        onClick={addCourseBlock}
        variant={'outlined'}
        style={{ marginBottom: 16 }}
      >
        Добавить курс
      </Button>
    </>
  )
}
